"use client";

import { IconPlus } from "@intentui/icons";
import { useState } from "react";
import { Button } from "@/intent-components/ui/button";
import { AddOrCreateClient } from "./addOrCreateClient";

type AddNewClientProps = {
  allProfiles: {
    id: string;
    name: string;
    countryCode: string;
  }[];
};

export function AddNewClient({ allProfiles }: AddNewClientProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button onPress={() => setIsOpen(true)}>
        <IconPlus />
        Add New Client
      </Button>

      <AddOrCreateClient
        allProfiles={allProfiles}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  );
}
